import { useHead } from '@unhead/vue';

function isValidGTagId(id: string) {
    const gTagIdPattern = /^G-[A-Z0-9]{4,}$/;
    return gTagIdPattern.test(id);
}

let injected = false;

/**
 * Registers Google Analytics tracking scripts in the document head.
 *
 * Usage:
 * - Call once during app initialization (e.g., in the root component or
 *   a top-level layout) to enable Google Analytics tracking for the SPA.
 * - The composable performs side effects only and does not return a value.
 */
export function useGoogleAnalytics() {
    if (injected) return;

    const gTagId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID as string | undefined;
    const isEnabled = !!gTagId;

    if (!isEnabled) return;
    if (!isValidGTagId(gTagId)) {
        console.warn(
            `[useGoogleAnalytics] Invalid Google Analytics G-Tag ID: "${gTagId}". Google Analytics will not be initialized.`,
        );
        return;
    }
    injected = true;
    useHead({
        script: [
            {
                src: `https://www.googletagmanager.com/gtag/js?id=${gTagId}`,
                defer: true,
            },
            {
                innerHTML: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${gTagId}');
                `,
            },
        ],
    });
}
